import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import darkmodeRedcer from "../features/ModeSlice"
import {persistReducer} from 'redux-persist'
import todosReducer from '../features/TodosSlice'

const persistConfig={
  key:"root",
  version:1,
  storage
}

const reducer=combineReducers({
  theme:darkmodeRedcer,
  todos:todosReducer,

})

const persistedReducer=persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
  getDefaultMiddleware({
    serializableCheck: false,
  }),
});
